import { createContext } from "react";

const PathPreviewContext = createContext();

export default PathPreviewContext;
